import AmountSearch from './amountSearch';
import FieldSearch from './fieldSearch';

import './loadMasking';

export default AmountSearch.extend({
  onRender() {
    FieldSearch.prototype.onRender.call(this);
    this.ui.$focusField.maskNumeric();
    this.showDropdown();
  },

  onClose() {
    this.ui.$focusField.unmask();
  }
});
